import { createContext, useContext, useState } from "react";
import { toast } from "sonner";

const CompareContext = createContext(null);
const MAX = 4;

export function CompareProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("tfm_compare") || "[]"); } catch { return []; }
  });

  const persist = (next) => { localStorage.setItem("tfm_compare", JSON.stringify(next)); return next; };

  const toggle = (product) => {
    setItems((prev) => {
      const exists = prev.find((p) => p.id === product.id);
      if (exists) return persist(prev.filter((p) => p.id !== product.id));
      if (prev.length >= MAX) {
        toast.error(`You can compare up to ${MAX} products`);
        return prev;
      }
      toast.success(`${product.name} added to compare`);
      return persist([...prev, product]);
    });
  };

  const remove = (id) => setItems((prev) => persist(prev.filter((p) => p.id !== id)));
  const clear = () => setItems(persist([]));
  const has = (id) => !!items.find((p) => p.id === id);

  return (
    <CompareContext.Provider value={{ items, toggle, remove, clear, has }}>
      {children}
    </CompareContext.Provider>
  );
}

export const useCompare = () => useContext(CompareContext);
